module.exports = __webpack_public_path__ + "img/jes.3e47e93b.png";